var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSedan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.683 14.545l2.13.426a1.681 1.681 0 002.937.306h9.605a1.682 1.682 0 002.768 0h.799c.035 0 .07-.009.102-.024l1.455-.728a.228.228 0 00.126-.204v-1.455a.227.227 0 00-.067-.161l-.728-.728a.23.23 0 00-.123-.064l-4.333-.722-4.336-2.168A.23.23 0 0012.917 9H4.183a.228.228 0 00-.19.101L2.54 11.283v.001l-.001.002a.236.236 0 00-.025.052l-.004.014a.219.219 0 00-.009.06v2.91c0 .108.077.202.183.223zm3.684 1.005a1.23 1.23 0 01-1.229-1.228 1.23 1.23 0 111.228 1.228zm12.372 0a1.23 1.23 0 111.228-1.228 1.23 1.23 0 01-1.228 1.228zm-6.323-6.095h.447l3.458 1.728h-3.905V9.455zm-.455 0v1.728h-4.55l.575-1.728h3.975zm-7.656 0h3.202l-.577 1.728H3.153l1.152-1.728z",
    fill: "#000",
    fillRule: "nonzero"
  })));
}

export default SvgSedan;